import { WindowMetrics } from "../utilities/window-metrics.js";

export class HomePage {
    constructor(parameters) {
        var t = this;

        let root = document.documentElement;

        // let's move the red Alexion Connect div to tuck under 
        // the gray callout by updating the css variables 
        function overlapCallout() {
            var calloutHeight = document.querySelector('.callout').getBoundingClientRect().height,
                extraPadding,
                homeMargin = (calloutHeight / 2);

            if (WindowMetrics.isMobile()) {
                if (window.innerWidth < 375) {
                    extraPadding = 144;
                } else if (window.innerWidth < 400) {
                    extraPadding = 144 + ((window.innerWidth - 375) * 1.5);
                } else {
                    extraPadding = 48;
                }
            }
            else {
                extraPadding = 104;
            }

            root.style.setProperty('--home-margin', '-' + homeMargin + 'px');
            root.style.setProperty('--home-padding', homeMargin + extraPadding + 'px');

        }

        window.addEventListener('DOMContentLoaded', (event) => {
            overlapCallout();
        });

        window.addEventListener('resize', (event) => {
            overlapCallout();
        });

    }
}
